import {createAction, props} from '@ngrx/store';
import {AuthNgrx} from '~model/ngrx/auth-ngrx';

export enum FeatureAuthActionsTypes {
  SetAuth = '[Auth] setAuth',
  Login = '[Auth] login',
  LoginToken = '[Auth] loginToken',
  Reiniciar = '[Auth] reiniciar'
}

export const authSet = createAction(
  FeatureAuthActionsTypes.SetAuth,
  props<AuthNgrx>()
);

export const authLogin = createAction(
  FeatureAuthActionsTypes.Login,
  props<{
    usuario: string,
    senha: string,
    empresa: string
  }>()
);

export const authLoginToken = createAction(
  FeatureAuthActionsTypes.LoginToken,
  props<{token: string}>()
);

export const authReiniciar = createAction(FeatureAuthActionsTypes.Reiniciar);
